<!-- Left Nav -->
<template>
    <main class="messaging-layout page-layout">
        <header class="page-header mx-2"></header>
        <div class="page-content list-section position-relative h-100 mx-2">
            <section :class="`card w-100 h-100 ${showBanner ? 'custom-banner-padding' : 'pb-3'}`">
                <router-view />
            </section>
            <section v-if="showPatients || showEmployees" id="Patient_Section">
                <div class="row-span-2 h-100 p-0">
                    <div v-if="showPatients" class="row-span-2 h-100">
                        <PatientList v-model:showPatients="showPatients" />
                    </div>
                    <div v-if="showEmployees" class="row-span-2 h-100">
                        <EmployeeList v-model:showEmployees="showEmployees" />
                    </div>
                </div>
            </section>
            <div v-if="showBanner" class="banner-container pb-2">
                <a :href="banner.link" target="_blank" rel="noopener noreferrer" @click="addLog(banner)">
                    <img :src="banner.src" class="axxess-banner" />
                </a>
                <button class="banner-close" @click="closeBanner(banner)">X</button>
            </div>
        </div>
        <ChatTutorial v-if="showChatTutorial" />
    </main>
</template>

<script lang="ts" src="./CentralMessaging.ts"></script>
<style src="./CentralMessaging.scss"></style>
